import { lazy, Suspense, type ComponentProps } from "react";

const TradingChart = lazy(() => import("./TradingChart"));

function ChartSkeleton() {
  return (
    <div className="w-full h-64 rounded-lg bg-muted/40 animate-pulse" />
  );
}

export default function LazyTradingChart(props: ComponentProps<typeof TradingChart>) {
  return (
    <Suspense fallback={<ChartSkeleton />}>
      <TradingChart {...props} />
    </Suspense>
  );
}
